
export const UI_PROGRESS_BAR = '[UI] Set App Progress Bar';

export interface SetProgressBar {
  type: typeof UI_PROGRESS_BAR;
  payload: { state: boolean };
}

export const setProgressBar = (state: boolean): SetProgressBar => {
  return {
    type: UI_PROGRESS_BAR,
    payload: { state },
  };
};

export type UITypes = SetProgressBar;